import React from "react";
import { useSelector } from "react-redux";
import UsedInLink from "../UsedInLink";
import { selectEventHandlers } from "../../../store/slices/projectSlice";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import labels from "../../nodes/Logic/helpers/labels";

export default function ActionsPanel() {
  const eventHandlers = useSelector(selectEventHandlers);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2">
        <h5 className="card-title">
          Actions
          <HelpButton helpKey="actions-panel" />
        </h5>
      </div>
      <div className="card-body p-0">
        {
          <ul className="list-group list-group-flush">
            {[
              ...new Set(
                eventHandlers.flatMap((eh) =>
                  eh.Rules.flatMap((r) =>
                    r.Actions?.map((action) => action.Type) || []
                  )
                )
              ),
            ].map((actionType) => (
              <li key={actionType} className="list-group-item p-2">
                <div className="d-flex justify-content-between align-items-baseline">
                  <span className="">{labels[actionType]}</span>
                  <UsedInBadge arg={{ Type: actionType, UUID: actionType }} />
                </div>
              </li>
            ))}
          </ul>
        }
      </div>
    </div>
  );
}
